import { styled } from '@mui/material';

export const Fieldset = styled('fieldset')({
	padding: 0,
	margin: 0,
	border: 0,
});
